import { cn } from "@/lib/utils";
import { PlaylistItemDTO } from "../../lib/types";
import { useMemo } from "react";

type Props = {
  item: PlaylistItemDTO;
  isFullScreen?: boolean;
};

// Serves application/pdf content
export const DSPlayerDoc: React.FC<Props> = ({ item, isFullScreen }) => {
  // Create a URL with PDF viewer parameters to hide the sidebar and display in full screen
  const pdfUrl = useMemo(() => {
    const url = new URL(item.src);
    // Add PDF.js viewer parameters
    // #view=FitH - Fit to width
    // &toolbar=0 - Hide toolbar
    // &navpanes=0 - Hide navigation panes/sidebar
    // &scrollbar=0 - Hide scrollbar
    return `${url.toString()}#view=FitH&toolbar=0&navpanes=0&scrollbar=0`;
  }, [item.src]);

  return (
    <iframe
      className={cn("ds-player-img", isFullScreen && "with-full-screen")}
      id={item.id.toString()}
      src={pdfUrl}
      style={{ width: "100%", height: "100%", border: "none" }}
      title="PDF Document Viewer"
    />
  );
};
